// Блок 9: FAQ — аккордеон, 7 вопросов

import { useId, useState } from 'react';

interface FaqItemData {
  question: string;
  answer: string;
}

const faqs: FaqItemData[] = [
  {
    question: 'Мои данные в безопасности?',
    answer:
      'Да. Данные каждой компании изолированы (Row Level Security). Мы не используем ваши диалоги для обучения общей модели.',
  },
  {
    question: 'AI может отправить что-то не то?',
    answer:
      'В Shadow-режиме — нет. Каждый черновик проходит через оператора. Автоматическая отправка включается только когда вы решите.',
  },
  {
    question: 'Как быстро AI начнёт предлагать ответы?',
    answer:
      'С первого сообщения. Но качество растёт: после 20–50 диалогов черновики становятся точнее.',
  },
  {
    question: 'Что если AI не знает ответ?',
    answer:
      'Он скажет «я не уверен» и передаст диалог оператору. Никаких выдуманных ответов.',
  },
  {
    question: 'Чем это отличается от обычного чат-бота?',
    answer:
      'Обычный бот отвечает по шаблонам. Anima учится на реальных ответах вашей команды и перенимает стиль общения.',
  },
  {
    question: 'Какие каналы поддерживаются?',
    answer:
      'Email (IMAP), Telegram и виджет для сайта. Планируем WhatsApp и Instagram.',
  },
  {
    question: 'Можно подключить свою базу знаний?',
    answer:
      'Да. Загружайте документы, ссылки, таблицы — AI будет использовать их для ответов.',
  },
];

function FaqItem({ question, answer }: FaqItemData): JSX.Element {
  const [open, setOpen] = useState(false);
  const panelId = useId();

  return (
    <div className="border border-border-subtle rounded-card bg-white overflow-hidden transition-colors hover:border-border-strong">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
        aria-expanded={open}
        aria-controls={panelId}
      >
        <span className="font-heading text-sm font-bold text-text-primary">{question}</span>
        <svg
          className={`w-4 h-4 text-text-muted flex-shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
      </button>
      <div
        id={panelId}
        role="region"
        className={`px-5 overflow-hidden transition-all duration-200 ${open ? 'max-h-60 pb-4' : 'max-h-0'}`}
      >
        <p className="text-sm text-text-secondary leading-relaxed">{answer}</p>
      </div>
    </div>
  );
}

export function FaqSection(): JSX.Element {
  return (
    <section className="py-20 lg:py-28 bg-surface-subtle">
      <div className="max-w-2xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl sm:text-4xl font-extrabold text-text-primary tracking-tight">
            Вопросы и ответы
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq) => (
            <FaqItem key={faq.question} {...faq} />
          ))}
        </div>
      </div>
    </section>
  );
}
